define('bindingHandlers/droparea',[
    'lib/lodash4',
    'lib/knockout',
    'jquery'
], function (_, ko, $) {
    'use strict';

    var CLASS_DRAGOVER = 'dragover',
        NAMESPACE      = '.droparea',

        /**
         * Returns a filter based on the passed in data transfer object that returns true for any non folder file.
         * @param dt
         * @returns {Function}
         */
        isFile = function(dt) {
            var items = _.toArray(dt.items),
                directoryMap = {};

            _.each(items, function(dtItem){
                if (_.isFunction(dtItem.webkitGetAsEntry)) {
                    var entry = dtItem.webkitGetAsEntry();
                    if ( entry && entry.isDirectory ) {
                        directoryMap[ entry.name ] = true;
                    }
                }
            });

            return function(file){
                var isDirectory = directoryMap[file.name],
                    isUnTyped   = file.type === '',
                    isEmpty     = file.size === 0;

                return !isDirectory && !( isUnTyped && isEmpty );
            };
        },

        /**
         * Checks to see if the x and y coordinates passed in are within the bounding area
         * of the target element
         * @param $element
         * @param x
         * @param y
         * @returns {boolean}
         */
        isWithinBounds = function( $element, x, y ) {
            var element = $element[0],
                rect = element.getBoundingClientRect();

            return rect.left   < x &&
                   rect.right  > x &&
                   rect.top    < y &&
                   rect.bottom > y;
        },

        /**
         * Toggles the dragOver class when dragging within the bounds of the droparea
         *
         * @param $element - the target element that accepts the drag/drop
         * @param event - the drag event
         * @param isDragging - true if dragging, false otherwise.  If this flag is false
         * the dragOver class is always removed
         */
        toggleDragOverClass = function( $element, event, isDragging ) {
            var evt     = event.originalEvent,
                target  = evt.target,
                isValid = target === $element[0] || $element.has( target ).length > 0;

            if ( isDragging && isValid && isWithinBounds($element, evt.clientX, evt.clientY)) {
                $element.addClass(CLASS_DRAGOVER);
            } else {
                $element.removeClass(CLASS_DRAGOVER);
            }
        },

        /**
         * Filters the drops to exclude directories - returning only the files dropped into the dropArea.
         * @param e
         * @param noFolders - if true - filters the files so no folders are included in the output
         * @returns {*}
         */
        getFilesForDrop = function(e, noFolders){
            var dt = e.dataTransfer,
                files = _.toArray(dt.files);

            if (noFolders) {
                return _.filter(files, isFile(dt));
            }
            return files;
        },

        /**
         * Adds the passed in dropEffect to the event dataTransfer object
         * @param event - the event passed in
         * @param effect - the dropEffect string
         */
        addDropEffect = function(event, effect){
            if (effect && event.originalEvent && event.originalEvent.dataTransfer ){
                event.originalEvent.dataTransfer.dropEffect = effect;
            }
        };


    /**
     * The DropArea Binding handler
     *
     * Makes a DOM element responsive to the 'Drop' event.  When the user drags items over elements
     * invoking this binding handler, the bound element is decorated with a "dragover" class - which may alter the
     * view in order to instruct the user to drop or point the user at a target.  When the user drops
     * the files, the dropHandler is invoked - passing in the files added to the receiving viewModel and the "dragOver"
     * class is removed.
     *
     * Required:
     * @param drop - observable that will receive the files dragged and dropped into the droparea
     * @param dropEffect - String represents the behavior on drop.  Effects allowed are copy, move, link, and none.
     *
     * @Example
     *  <div data-bind="droparea: { drop: droppedFiles }"></div>
     */
    ko.bindingHandlers.droparea = {
        init: function (element, valueAccessor) {
            var options  = ko.unwrap( valueAccessor()),
                dropEffect = options.dropEffect,
                $element = $(element),
                isDragging = false,

                onDragEnter = function(event) {
                    addDropEffect(event, dropEffect);
                    isDragging = true;
                    $element.addClass( CLASS_DRAGOVER );
                    event.preventDefault();
                    return false;
                },

                onDragOver = function(event) {
                    addDropEffect(event, dropEffect);
                    event.preventDefault();
                    toggleDragOverClass( $element, event, isDragging);
                    return false;
                },

                onDragLeave = function(event) {
                    event.preventDefault();
                    toggleDragOverClass( $element, event, isDragging);
                },

                onDrop = function(event) {
                    isDragging = false;
                    if (_.isFunction( options.drop )) {
                        options.drop(getFilesForDrop( event.originalEvent, ko.unwrap(options.noFolders) ), event);
                    }

                    $element.removeClass( CLASS_DRAGOVER );

                    event.preventDefault();
                    return false;
                },
                onBodyDragDrop = function(event) {
                    event.preventDefault();
                    return false;
                };

            $element
                .on('dragenter' + NAMESPACE, onDragEnter)
                .on('dragover'  + NAMESPACE, onDragOver )
                .on('dragleave' + NAMESPACE, onDragLeave)
                .on('drop'      + NAMESPACE, onDrop     );

            $(document.body)
                .on('dragenter' + NAMESPACE, onBodyDragDrop)
                .on('drop'      + NAMESPACE, onBodyDragDrop)
                .on('dragover'  + NAMESPACE, onBodyDragDrop);

            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                $(element).off(NAMESPACE);
                $(document.body).off(NAMESPACE);
            });
        }
    };
});

